import { render, staticRenderFns } from "./StockPurchaseReportConsolidated.vue?vue&type=template&id=2a3af130&"
import script from "./StockPurchaseReportConsolidated.vue?vue&type=script&lang=js&"
export * from "./StockPurchaseReportConsolidated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports